export default __webpack_public_path__ + "static/media/1946.79bb78c9.png";